import SharedTypes from './SharedTypes';
import { ClientsSharedTypes } from 'st-clients/ClientsSharedTypes';
import { AwardsSharedTypes } from 'st-awards/AwardsSharedTypes';
import { AllocationManagerSharedTypes } from 'st-allocationmanager/AllocationManagerSharedTypes';
import { AppServices } from '@singularsystems/neo-core';
import { NeoReactTypes } from '@singularsystems/neo-react';
import { ParticipantsIdentitySharedTypes } from 'st-identity';
import { TransactionsSharedTypes } from 'st-transactions/TransactionsSharedTypes';
import { DividendsSharedTypes } from 'st-dividends/DividendsSharedTypes'
import { ParticipantsSharedTypes } from 'st-participants/ParticipantsSharedTypes';
import { ReportingTypes } from 'st-reporting/ReportingTypes';

// All shared type symbols for the app
const Types = {
    Neo: {
        ...AppServices.NeoTypes,
        ...NeoReactTypes
    },
    Shared: SharedTypes,
    Clients: ClientsSharedTypes,
    Awards: AwardsSharedTypes,
    Identity: ParticipantsIdentitySharedTypes,
    Transactions: TransactionsSharedTypes,
    Dividends: DividendsSharedTypes,
    Participants: ParticipantsSharedTypes,
    Reporting: ReportingTypes,
    AllocationManager: AllocationManagerSharedTypes,
}

export default Types
